 
// export const apiUrl = 'http://139.59.15.241:8000'; 
// export const apiUrl = 'http://127.0.0.1:8000'; 

export const apiUrl = 'https://www.marquisdevelopers.com/admin-panel'; 

export const imgUrl = 'https://www.marquisdevelopers.com/admin-panel';

// export const imgUrl = 'http://139.59.15.241:8000';
// export const imgUrl = 'http://127.0.0.1:8000';
